import { createFileRoute } from "@tanstack/react-router";
import { logout } from "@/server/auth/logout";

export const Route = createFileRoute("/_auth/logout")({
  preload: false,
  loader: () => logout(),
  component: () => {
    window.location.href = "/login";
  },
});
